import { CollaborationV1AttachmentLabelsEntryInput } from '@spotify/confidence-graphql';

export const IMAGE_ARTIFACT_LABEL: CollaborationV1AttachmentLabelsEntryInput = {
  key: 'type',
  value: 'image',
};

export const isImageArtifactLabel = (
  labels?: ReadonlyArray<{ key: string; value?: string | null }> | null,
): boolean =>
  labels?.some(l => l.key === 'type' && l.value === 'image') ?? false;
